import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Register = () => {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ first_name: '', last_name: '', username: '', email: '', phone: '', password: '' });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const submit = async event => {
        event.preventDefault();
        if (saving) return;
        setSaving(true); setError('');
        try {
            const result = await register({ ...form, user_level: 'tenant' });
            if (result.success) navigate('/login');
            else setError(result.message || 'Unable to create account');
        } finally { setSaving(false); }
    };
    return <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-white border border-neutral-200 rounded-xl p-8 space-y-5">
            <div><h1 className="text-2xl font-bold text-neutral-900">Create a tenant account</h1><p className="text-sm text-neutral-500 mt-2">Your property manager will link your lease. Staff and owner accounts are created by an administrator.</p></div>
            {error && <p role="alert" className="text-sm text-danger-700">{error}</p>}
            <form onSubmit={submit} className="space-y-4">
                {[['first_name', 'First name', 'text', 50], ['last_name', 'Last name', 'text', 50], ['username', 'Username', 'text', 50], ['email', 'Email', 'email', 100], ['phone', 'Phone (optional)', 'tel', 20], ['password', 'Password', 'password', 72]].map(([key, label, type, max]) =>
                    <label key={key} className="block text-sm font-medium text-neutral-700">{label}<input className="input mt-1" type={type} required={key !== 'phone'} autoComplete={key === 'password' ? 'new-password' : undefined}
                        minLength={key === 'password' ? 8 : key === 'username' ? 3 : undefined} maxLength={max} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} /></label>)}
                <p className="text-xs text-neutral-500">Use a password of 8–72 characters.</p>
                <button className="btn-primary w-full" disabled={saving}>{saving ? 'Creating…' : 'Create tenant account'}</button>
            </form>
            <Link className="block text-sm text-primary-700" to="/login">Already have an account? Sign in</Link>
        </div>
    </div>;
};
export default Register;
